import React from 'react';
import LazyLoad from 'react-lazyload';

import Button from 'shared-components/Button/Button';
import { track, segmentEnum } from 'utils/segment';
import styles from './ExclusiveOffers.module.css';

const CHAR_COUNT = 50;

const OfferCard = ({
  isDesktop,
  trackingData,
  offer,
  onCopyCode,
  copiedCode,
}) => {
  const { offerId, offerName, image, offerCode, text, url, rule } = offer;
  const offerCodeId = offerCode + offerId;

  const openNewtab = () => {
    window.open(url, '_blank');
  };
  const handleExclusiveOfferTracking = (experience, elementName) => {
    track(segmentEnum.clickedElement, {
      ...trackingData,
      experience,
      element_name: elementName,
    });
  };

  const copyToClipboardAndTracking = () => {
    onCopyCode(offerId, offerCode);
    handleExclusiveOfferTracking(
      'Exclusive Offer Copied',
      `${offerName} - ${offerCode}`
    );
  };

  return (
    <li>
      <div className={styles.offerCard}>
        <div className={styles.offerDetailsContainer}>
          <div className={styles.imageContainer}>
            <LazyLoad once>
              <img src={image} alt={offerCode} />
            </LazyLoad>
          </div>

          <div className={styles.offerDetails}>
            <div className={styles.offerName}>{offerName}</div>
            <div
              className={
                text.length > CHAR_COUNT
                  ? styles.offerSmallText
                  : styles.offerText
              }
            >
              {text}
            </div>
            <button
              type="button"
              id={offerCodeId}
              className={styles.offerCode}
              onClick={() => copyToClipboardAndTracking()}
            >
              {offerCode}
            </button>
            <div className={styles.copyContainer}>
              {copiedCode ? (
                <p className={styles.copiedMsg}>code is copied</p>
              ) : (
                <>
                  <i className="far fa-copy fa-xs" />
                  <p className={styles.copyMsg}>
                    {isDesktop
                      ? 'click the code to copy it'
                      : 'tap the code to copy it'}
                  </p>
                </>
              )}
            </div>
            {isDesktop && (
              <div className={styles.buttonWrapper}>
                <Button
                  buttonType="primary"
                  style={{ width: 262, padding: 0 }}
                  onClick={() => {
                    handleExclusiveOfferTracking(
                      'Exclusive Offer Redirect',
                      `SHOP NOW (${offerName} - ${offerCode})`
                    );
                    openNewtab(url);
                  }}
                >
                  shop now
                </Button>
              </div>
            )}
          </div>
        </div>
        {!isDesktop && (
          <div className={styles.buttonWrapper}>
            <Button
              buttonType="primary"
              style={{ width: '100%' }}
              onClick={() => {
                handleExclusiveOfferTracking(
                  'Exclusive Offer Redirect',
                  `SHOP NOW (${offerName} - ${offerCode})`
                );
                openNewtab(url);
              }}
            >
              shop now
            </Button>
          </div>
        )}
      </div>
      <div
        className={styles.footNote}
        dangerouslySetInnerHTML={{ __html: rule }}
      />
    </li>
  );
};

export default OfferCard;
